/* CDN-BUMP-20260803T1750 */
/**
 * Wudy — market path + currency alignment for Shopify Markets.
 * UK catalog lives under /en-gb/; root URLs default to USD (primary market).
 */
/* WUDY-CA-CLOSED-20260803: strip retired market folders (Canada etc.) using browser pathname.
   Liquid request.path is "/404" on missing market URLs, so theme.liquid-only redirects miss them. */
(function () {
  var p = window.location.pathname || '';
  var retired = ['/en-ca', '/fr-ca', '/de-de', '/en-de', '/en-au', '/en-sg'];
  for (var i = 0; i < retired.length; i++) {
    var pref = retired[i];
    if (p === pref || p === pref + '/' || p.indexOf(pref + '/') === 0) {
      var next = p.slice(pref.length) || '/';
      window.location.replace(next + (window.location.search || '') + (window.location.hash || ''));
      return;
    }
  }
})();

(function () {
  'use strict';

  var MARKET_PREFIX = {
    GB: '/en-gb',
  };

  var ROOT_PREFIXES = ['/en-gb'];

  function currentPrefix() {
    var path = window.location.pathname;
    for (var i = 0; i < ROOT_PREFIXES.length; i++) {
      if (path === ROOT_PREFIXES[i] || path.indexOf(ROOT_PREFIXES[i] + '/') === 0) {
        return ROOT_PREFIXES[i];
      }
    }
    return '';
  }

  function shouldSkipRedirect() {
    var path = window.location.pathname;
    if (path.indexOf('/checkout') === 0) return true;
    if (path.indexOf('/cart') === 0) return true;
    if (path.indexOf('/admin') === 0) return true;
    if (window.Shopify && Shopify.designMode) return true;
    if (sessionStorage.getItem('wudy_market_redirect_skip') === '1') return true;
    var lastAt = parseInt(sessionStorage.getItem('wudy_market_redirect_at') || '0', 10);
    if (lastAt && Date.now() - lastAt < 15000) return true;
    return false;
  }

  function stripMarketPrefix(path) {
    for (var i = 0; i < ROOT_PREFIXES.length; i++) {
      var prefix = ROOT_PREFIXES[i];
      if (path === prefix || path === prefix + '/') return '/';
      if (path.indexOf(prefix + '/') === 0) return path.slice(prefix.length) || '/';
    }
    return path;
  }

  function redirectToMarket(countryCode) {
    var prefix = MARKET_PREFIX[countryCode];
    if (!prefix || currentPrefix() === prefix) return;

    var path = stripMarketPrefix(window.location.pathname);
    var search = window.location.search || '';
    var hash = window.location.hash || '';
    sessionStorage.setItem('wudy_market_redirect_at', String(Date.now()));
    window.location.replace(prefix + path + search + hash);
  }

  function wasStrippedFromEnGb() {
    try {
      var ref = document.referrer;
      if (!ref) return false;
      var refUrl = new URL(ref);
      if (refUrl.hostname !== window.location.hostname) return false;
      var refPath = refUrl.pathname;
      return refPath === '/en-gb' || refPath.indexOf('/en-gb/') === 0;
    } catch (e) {
      return false;
    }
  }

  function hasLegacyStripWithoutGuard() {
    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i++) {
      var text = scripts[i].textContent || '';
      if (
        text.indexOf('location.replace(target)') > -1 &&
        text.indexOf('__WUDY_KEEP_MARKET_PREFIX') < 0 &&
        text.indexOf("path.indexOf('/en-gb/')") < 0
      ) {
        return true;
      }
    }
    return false;
  }

  function maybeGeoRedirect() {
    if (shouldSkipRedirect()) return;
    if (currentPrefix()) return;
    if (wasStrippedFromEnGb()) return;
    if (hasLegacyStripWithoutGuard()) return;

    fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (data) {
        if (!data || !data.detected_values || !data.detected_values.country) return;
        var handle = data.detected_values.country.handle;
        if (handle && MARKET_PREFIX[handle]) {
          redirectToMarket(handle);
        }
      })
      .catch(function () {});
  }

  function bindFooterCountrySelect() {
    var select = document.getElementById('FooterCountryCode');
    if (!select || select.dataset.wudyMarketBound === 'true') return;
    select.dataset.wudyMarketBound = 'true';

    select.addEventListener('change', function () {
      var form = select.form;
      if (!form) return;

      var returnTo = form.querySelector('input[name="return_to"]');
      var code = select.value;
      var targetPrefix = MARKET_PREFIX[code] || '';
      var activePrefix = currentPrefix();
      var path = stripMarketPrefix(window.location.pathname);
      var search = window.location.search || '';

      if (returnTo) {
        if (targetPrefix && activePrefix !== targetPrefix) {
          returnTo.value = targetPrefix + path + search;
        } else if (!targetPrefix && activePrefix) {
          returnTo.value = path + search;
        } else {
          returnTo.value = (activePrefix || '') + path + search;
        }
      }

      form.submit();
    });
  }

  function prefixInternalLinks() {
    var prefix = currentPrefix();
    if (!prefix) return;

    document.querySelectorAll('a[href^="/"]').forEach(function (anchor) {
      var href = anchor.getAttribute('href');
      if (!href || href === prefix || href.indexOf(prefix + '/') === 0) return;
      if (href.indexOf('/cdn/') === 0 || href.indexOf('/a/') === 0) return;
      anchor.setAttribute('href', prefix + href);
    });
  }

  function boot() {
    maybeGeoRedirect();
    bindFooterCountrySelect();
    prefixInternalLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
;/* force-publish 1785769406 */
